module.exports = __webpack_public_path__ + "assets/img/453d-gg.svg";